/**
 * avatar — 아바타 이니셜 + 색상 (HTML 시안 팔레트)
 *
 * 동적 메타모델: 모듈 분기 없음. 이름/식별자 기반 결정적 색.
 * 데모 인물은 HTML 원본과 동일 색으로 매핑(요청자 아바타 색 100% 일치),
 * 그 외는 안정 해시 팔레트.
 */
import { readKey } from "@/lib/safeAccess";

/**
 * HTML 원본 데모 인물 → 아바타 배경색 (verbatim, 목업 §9 감사피드 팔레트 실측).
 * 신=#4f46e5, 최=#6d5bd0, 정=#c77a12, 한=#0e9488(틸), 이=#2a93dc, 김=#16a06a.
 */
const NAME_COLOR: Record<string, string> = {
  신하영: "#4f46e5",
  정도윤: "#c77a12",
  박지훈: "#e0436a",
  이서민: "#2a93dc",
  김재원: "#16a06a",
  최민서: "#6d5bd0",
  한지우: "#0e9488",
  "데모 관리자": "#4f46e5", // i18n-allow: 샘플 사람 이름(예시 데이터)
};

/** HTML 아바타 팔레트(해시 폴백) */
const PALETTE = [
  "#4f46e5",
  "#2a93dc",
  "#16a06a",
  "#c77a12",
  "#e0436a",
  "#6d5bd0",
  "#0891b2",
  "#db2777",
];

function hashIndex(input: string, mod: number): number {
  let h = 0;
  for (let i = 0; i < input.length; i++) h = (h * 31 + input.charCodeAt(i)) | 0;
  return Math.abs(h) % mod;
}

/** 이름 → 배경색 (데모 인물은 HTML과 동일, 그 외 해시) */
export function avatarColorFor(seed: string | null | undefined, name?: string | null): string {
  const n = (name ?? "").trim();
  if (n && readKey(NAME_COLOR, n)) return readKey(NAME_COLOR, n);
  return PALETTE[hashIndex((seed || name || "?").toString(), PALETTE.length)];
}

/** 이름 → 이니셜 (한글 1자 / 영문 첫 2자) */
export function initialsOf(name?: string | null): string {
  const t = (name ?? "").trim();
  if (!t) return "?";
  const parts = t.split(/\s+/);
  if (parts.length >= 2 && !/[가-힣]/.test(t)) return (parts[0][0] + parts[1][0]).toUpperCase();
  if (/[가-힣]/.test(t)) return t.replace(/\s+/g, "").slice(0, 1);
  return t.slice(0, 2).toUpperCase();
}
